import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { MarketplaceCategoriesResponse } from 'src/types/view_catalogs/MarketplaceCategories';
import axiosInstance from 'src/utils/axios';

async function fetchMarketplaceCategories(): Promise<MarketplaceCategoriesResponse[]> {
  const res = await axiosInstance.get<MarketplaceCategoriesResponse[]>(api.marketplacecategories);
  return res.data;
}

const useGetMarketplaceCategories = () =>
  useQuery<MarketplaceCategoriesResponse[]>({
    queryKey: queryKeys.marketplaceCategories.marketplaceCategories(),
    queryFn: fetchMarketplaceCategories,
  });

export default useGetMarketplaceCategories;
